<template>
<main class="container-1-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <h2>Editar usuario</h2>
    </div>

    <div class="container-action">
        
    </div>

    <div class="container-body">
        <label for="firstname">Nombre</label>
        <input id="firstname" v-model="user.firstname" type="text"
        name="nombre" :class="{'error' : errors.has('nombre') }" v-validate="'required'"
        :placeholder="[[errors.has('nombre') ? errors.first('nombre') : 'Ingresa el nombre']]"/>

        <label for="lastname">Apellidos</label>
        <input id="lastname" v-model="user.lastname" type="text"
        name="apellidos" :class="{'error' : errors.has('apellidos') }" v-validate="'required'"
        :placeholder="[[errors.has('apellidos') ? errors.first('apellidos') : 'Ingresa los apellidos']]"/>

        <label for="group">Grupo del usuario</label>
        <select id="group"
        v-model="user.id_group"
        name="grupo del usuario" :class="{'error' : errors.has('grupo del usuario') }" v-validate="groupsIncluded">
            <option
            value="-1"
            disabled
            >
                Selecciona un grupo
            </option>
            <option
            v-for="item in groups"
            v-bind:key="item.index"
            v-bind:value="item.id">
            {{item.name}}
            </option>
        </select>

        
        <label for="username">Correo electrónico</label>
        <input id="username" v-model="user.username" type="text"
        name="nombre de usuario" :class="{'error' : errors.has('nombre de usuario') }" v-validate="'required|email|unique'"
        :placeholder="[[errors.has('nombre de usuario') ? errors.first('nombre de usuario') : 'Escribe el nombre de usuario']]"/>

        <label for="permissions">Permisos de usuario</label>
        <div id="permissions">
                <!--Nombres nuevos segun observacion de SENAPRED 06/2026 ("1. En la creación y en la edición, el nombre de los permisos debe ser el mismo que aparece en ver usuarios.")-->
                <!--Se elimina geoprocesos porque la vista asociada esta deshabilitada (revision SENAPRED 06/2026)-->
            <input v-if="user.permissions" type="checkbox" id="checkbox" v-model="user.permissions.users">
            <label for="checkbox">Administración de usuarios</label>
            <br>
            <input v-if="user.permissions" type="checkbox" id="checkbox" v-model="user.permissions.layers">
            <label for="checkbox">Administración de capas</label>
            <br>
            <input v-if="user.permissions" type="checkbox" id="checkbox" v-model="user.permissions.maps">
            <label for="checkbox">Administración de mapas</label>
            <br>
            <input v-if="user.permissions" type="checkbox" id="checkbox" v-model="user.permissions.visor">
            <label for="checkbox">Acceso al visor</label>
            <br>
            <input v-if="user.permissions" type="checkbox" id="checkbox" v-model="user.permissions.documents">
            <label for="checkbox">Administración de documentos</label>
        </div>
        
        <div class="container-action-left" style="justify-content: start;">
            <button class="btn btn-secondary" v-on:click="onClickGoBack()">Volver</button>
            <button class="btn btn-secondary" v-on:click="onClickGoNext()">Actualizar usuario</button>
        </div>

    </div>

    <div class="container-list"> 
        
    </div>
 
</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'

import {restUser} from '@/components/mixin/restUser.js'
import {restGroup} from '@/components/mixin/restGroup.js'

export default{
    name: 'test',
    mixins: [restUser, restGroup],
    data(){
        return{
            actualUsername: '',
            deletePressed: false,
        }
    },
    components:{
        Breadcrumb
    },
    computed: {
        routesBread: function(){
          return [
              {name:'Usuarios', path: '/usuarios' },
              {name: this.user.firstname + ' ' + this.user.lastname, path: '/usuarios/' + this.$route.params.idUser},
              {name: 'Editar usuario'}
              ]
        },
        groupsIncluded: function(){
            let list = 'included:';
            for (let i = 0; i < this.groups.length; i++) {
                list = list + this.groups[i].id.toString() + ',';
            }
            return list;
        }
    },
    props: [],
    methods:{
        onClickGoBack: function() {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push('/usuarios/' + this.$route.params.idUser)
        },
        onClickGoNext: function() {
            var that = this;
            this.$validator.validateAll()
            .then(function (response) {
                if(response) {
                    that.putUser();
                } else {
                }
            })
        }
    },
    updated () {

    },
    created () {
        //Verificar permisos
        this.$store.getters.getPermissions.users? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getGroupsNoPages();
        this.getUser();

        //Verificar username único en servidor
        const isUnique = (value) => {
            var that = this;
            return this.$http.post(this.$store.getters.backendurl + 'api/v1/accounts/check', {username: value})
            .then(function (response) {
                if (that.actualUsername == value) {
                    return {
                        valid: true,
                        data: {
                            message: "Es el mismo correo ya registrado"
                        }
                    };
                }
                return {
                    valid: response.data.valid,
                    data: {
                        message: response.data.message
                    }
                };
            })
            .catch(function (error) {
                console.log(error);
                return {
                    valid: false,
                    data: {
                        message: "No se puede verificar"
                    }
                }
            });
        };
        this.$validator.extend('unique', {
            validate: isUnique,
            getMessage: (field, params, data) => {
                return data.message;
            }
        });
    }
}
</script>

<style lang="scss" scoped>

</style>
